import React, { useCallback, useEffect, useMemo, useState } from 'react';
import intl from 'react-intl-universal';

import { formatMts } from '@/utils';

import PC from './pc';
import M from './m';
import TransferCom from '../public/TransferCom';
import styles from './index.module.less';
import { NextImage } from '../public';

function ContactUS({ baseConfig }: { baseConfig: any }) {
    const { aboutUs, contactUs } = baseConfig;
    const [tabIndex, setTabIndex] = useState(0);
    const [showNoData, setShowNoData] = useState(false);

    /** tab切换 */
    const tabChange = (index: number) => {
        setTabIndex(index);
    };

    /** 富文本内容 */
    const richTextContent = useMemo(() => {
        switch (tabIndex) {
            case 0:
                return formatMts(contactUs);
            case 2:
                return formatMts(aboutUs);
            default:
                return '';
        }
    }, [contactUs, aboutUs, tabIndex]);

    /** 判断是否无数据 */
    useEffect(() => {
        switch (tabIndex) {
            case 0:
            case 2:
                if (richTextContent === '') {
                    setShowNoData(true);
                    return;
                }
                setShowNoData(false);
            default:
                setShowNoData(false);
        }
    }, [tabIndex, richTextContent]);

    /** 没数据时展示内容 */
    const noDataRender = useCallback(
        (show?: boolean) => {
            if (!showNoData && !show) {
                return null;
            }
            return (
                <div className={styles.empty}>
                    <div className={styles.empty__img}>
                        <NextImage layout="fill" src="/img/place/null_data_new.webp" alt="empty" />
                    </div>
                    <span>{intl.get('Common.NoData').d('暂无数据')}</span>
                </div>
            );
        },
        [showNoData],
    );

    const childrenProps = {
        richTextContent,
        tabIndex,
        tabChange,
        noDataRender,
    };

    return <TransferCom pc={<PC {...childrenProps} />} m={<M {...childrenProps} />} />;
}

export default ContactUS;
